module.exports = __webpack_public_path__ + "media/images/ohap_ui_folder_minus_outline_on-95bdd52520ab7ae61ed95c2a68486e8b.png";